import { useEffect, useState } from 'react';

const navLinks = [
  { label: '最新图集', href: '#latest' },
  { label: '热门作品', href: '#hot' },
  { label: '风格分类', href: '#styles' },
  { label: '画师精选', href: '#artists' },
  { label: '关于我们', href: '#about' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-t-shirt-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-50">
            娜美同人<span className="text-primary-400">图鉴</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-200 transition-colors hover:bg-background-200/60 hover:text-foreground-50"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅每日更新
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-200 transition-colors hover:bg-background-200/60 lg:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/60 bg-background-50/95 px-4 py-4 backdrop-blur-md lg:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-200 transition-colors hover:bg-background-200/60 hover:text-foreground-50"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                订阅每日更新
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}